var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.602,
    height: 26.117,
    viewBox: "0 0 26.602 26.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-microsoftexcel",
    "data-name": "Icon simple-microsoftexcel",
    d: "M26.107,3.524H17.195V5.173h2.627V7.783H17.195v.831h2.627v2.613H17.195v.855h2.627v2.471H17.195v.99h2.627v2.476H17.195v.99h2.627V21.5H17.195v1.817h8.912c.141-.042.258-.208.352-.5a2.431,2.431,0,0,0,.143-.7V3.826c0-.142-.049-.227-.143-.257A1.219,1.219,0,0,0,26.107,3.524ZM24.951,21.5H20.675V19.008h4.275V21.5Zm0-3.478H20.675V15.54h4.275Zm0-3.467H20.675v-2.46h4.275v2.46Zm0-3.325H20.675V8.616h4.275v2.61h0Zm0-3.457H20.675V5.175h4.275V7.768ZM0,3.113V23.731l15.7,2.715V.329L0,3.122Zm9.3,15.6q-.09-.243-.84-2.065c-.5-1.215-.8-1.922-.886-2.124H7.549L5.866,18.528l-2.25-.152,2.669-4.988L3.841,8.4l2.294-.121,1.516,3.9h.03L9.394,8.1l2.371-.15-2.823,5.4,2.91,5.507L9.3,18.707Z",
    transform: "translate(0 -0.328)",
    fill: "#0a8158"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.d548438b.svg";
export { ForwardRef as ReactComponent };